// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "0.0.16/static/css/" + "main" + "." + "1d685b52" + ".css";
};